import { html } from '@polymer/polymer/polymer-element.js';
import { KatapultWidget } from './katapult-widget';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import '@polymer/paper-input/paper-textarea';
import '@polymer/iron-icons/av-icons';
import '@polymer/neon-animation/neon-animation.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '../../katapult-auth/katapult-auth';
import '../../katapult-toolbar/katapult-toolbar';
import '../../katapult-map-icons/katapult-map-icons';
import '../../paper-table/paper-table';
import '../../code-requests/katapult-task-submission.js';
import '../../style-modules/paper-table-style';
import '../../style-modules/paper-dialog-style';
import '../../style-modules/paper-menu-button-style.js';
import '../../katapult-elements/katapult-button.js';
import './stopwatch.js';
import { ToArray } from '../../../modules/ToArray.js';
import { SquashNulls } from '../../../modules/SquashNulls.js';
import { OpenPage } from '../../../modules/OpenPage';
import { Path } from '../../../modules/Path.js';

// class TestWidget extends KatapultWidget {
class KatapultTaskWidget extends KatapultWidget {
  static get dataBaseTemplate() {
    return html`
      <katapult-firebase-worker
        id="taskList"
        path="photoheight/company_space/[[userGroup]]/tasks/tasks"
        order-by-child="[[getTaskListOrderByChild(disableUserTasks, userPushId, assignedKey)]]"
        equal-to="[[getTaskListEqualTo(disableUserTasks, assignedValue)]]"
        data="{{taskList}}"
        disabled="[[disableTaskList]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker id="users" path="photoheight/company_space/[[userGroup]]/users" data="{{users}}"></katapult-firebase-worker>
      <katapult-task-submission
        id="taskSubmissionForm"
        user-group="[[userGroup]]"
        code-requests-path="photoheight/company_space/[[userGroup]]/tasks"
        task-data="{{selectedTaskData}}"
        tasks-path="[[tasksPath]]"
        submission-type="[[submissionType]]"
        job-id="[[jobId]]"
        signed-in="[[signedIn]]"
      ></katapult-task-submission>
      <paper-dialog id="taskMembersDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title secondary-color>Manage Task Members</div>
        <div body>
          <paper-table outline dividers rounded>
            <template is="dom-repeat" items="[[editingTaskMembers]]" as="pushId" on-dom-change="resizeTaskMembersDialog">
              <paper-row>
                <paper-cell>
                  <user-chip email="[[getUserEmail(pushId, users.*)]]"></user-chip>
                </paper-cell>
                <paper-cell icon-button>
                  <katapult-button iconOnly noBorder icon="clear" on-click="removeTaskMembers"></katapult-button>
                </paper-cell>
              </paper-row>
            </template>
            <paper-row>
              <paper-cell>
                <katapult-drop-down
                  items="[[users]]"
                  label-path="email"
                  value-path="$key"
                  label="Choose a Member"
                  no-label-float
                  on-selected-changed="editTaskMembersDropdownChanged"
                  dynamic-align=""
                ></katapult-drop-down>
              </paper-cell>
            </paper-row>
          </paper-table>
        </div>
        <div buttons>
          <katapult-button outline dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--secondary-color)" loading="[[savingTaskTeamMembers]]" on-click="saveTaskMembers"
            >Save</katapult-button
          >
        </div>
      </paper-dialog>
    `;
  }

  static get widgetTitleTemplate() {
    return html`My Tasks`;
  }

  static get bodyTemplate() {
    return html`
      <style include="paper-table-style paper-dialog-style paper-menu-button-style">
        paper-row {
          height: auto;
        }
        paper-cell[textarea] {
          padding: 0;
        }
        paper-checkbox {
          --primary-color: var(--secondary-color);
        }
        paper-textarea {
          --primary-color: var(--secondary-color);
          flex-grow: 1;
          --paper-input-container-underline_-_display: none;
        }
        paper-row[completed] {
          opacity: 0.7;
        }
        paper-row[completed] paper-textarea {
          --iron-autogrow-textarea_-_text-decoration: line-through;
        }
        [slot='sortable'] paper-row {
          transition: background-color 0.3s;
        }
        paper-row:hover {
          z-index: 2;
        }
        [slot='sortable'] paper-row:not([slot='after']):hover,
        .dragging {
          background: var(--paper-grey-50);
        }
        [hover] {
          opacity: 0;
          transition: opacity 0.3s;
        }
        [hide-hover] {
          opacity: 1;
          transition: opacity 0.3s;
        }
        [slot='sortable'] paper-row:not([slot='after']):hover [hover] {
          opacity: 1;
        }
        [slot='sortable'] paper-row:hover [hide-hover] {
          opacity: 0;
        }
        .overlappingContainer {
          position: relative;
        }
        .overlappingContainer > div {
          position: absolute;
        }
        .notificationDot {
          background: var(--secondary-color);
          padding: 4px;
          border-radius: 100%;
        }
        paper-item:hover {
          cursor: pointer;
        }
        .optionsMenu iron-icon {
          margin-right: 10px;
        }
        .optionsMenu paper-item {
          white-space: nowrap;
          padding: 0 16px !important;
          color: var(--primary-text-color);
        }
        .optionsMenu paper-item iron-icon {
          color: var(--primary-text-color-faded);
        }
        .optionsMenu paper-item:hover {
          background-color: var(--paper-grey-50);
        }
      </style>
      <paper-table style="overflow: hidden; display: table; width: 100%" grey dividers>
        <paper-table-scroll style="overflow: hidden" grey on-sort-changed="taskListSortChanged">
          <template is="dom-repeat" items="[[taskListArray]]" on-dom-change="taskListDomChanged">
            <div class="rowContainer" slot="[[getTaskSlot(item.status)]]">
              <paper-row white divider completed$="[[equal(item.status, 'done')]]">
                <paper-cell class="overlappingContainer" icon drag-handle>
                  <iron-icon hover icon="katapult-misc:drag-indicator"></iron-icon>
                  <template is="dom-if" if="[[!item.seenVal]]">
                    <div hide-hover class="notificationDot"></div>
                  </template>
                </paper-cell>
                <paper-cell icon>
                  <paper-checkbox checked="[[equal(item.status, 'done')]]" on-click="toggleTaskComplete"></paper-checkbox>
                </paper-cell>
                <paper-cell textarea>
                  <paper-textarea
                    id$="task_[[item.$key]]_input"
                    value="[[item.title]]"
                    on-keydown="taskInputKeydown"
                    no-label-float
                    on-value-changed="taskInputChanged"
                    on-focus="closeOptionsMenus"
                  ></paper-textarea>
                </paper-cell>
                <stop-watch disabled="[[equal(item.status, 'done')]]" path="[[tasksRefPath]]/[[item.$key]]" id="stopwatch"></stop-watch>
                <template is="dom-repeat" items="[[item.members]]" as="pushId">
                  <user-chip email="[[getUserEmail(pushId, users.*)]]" hide-name></user-chip>
                </template>
                <template is="dom-if" if="[[shouldShowJobLinkButton(item.job_link_hash, disableUserTasks)]]">
                  <paper-cell icon-button>
                    <katapult-button
                      iconOnly
                      noBorder
                      on-click="openJobLink"
                      icon="open_in_new"
                      job-link-hash="[[item.job_link_hash]]"
                    ></katapult-button>
                  </paper-cell>
                </template>
                <paper-menu-button class="optionsMenu" horizontal-align="right" vertical-align="top" allow-outside-scroll>
                  <katapult-button iconOnly noBorder id="optionsMenuButton" slot="dropdown-trigger" icon="more_vert"></katapult-button>
                  <div slot="dropdown-content">
                    <paper-item id="editTaskMembers" on-click="editTaskMembers" slot="dropdown-content"
                      ><iron-icon icon="social:group-add"></iron-icon>Edit Task Members</paper-item
                    >
                    <paper-item id="editTask" on-click="editTask" slot="dropdown-content"
                      ><iron-icon icon="create"></iron-icon>Edit Task</paper-item
                    >
                    <paper-item id="addSubTask" on-click="addSubTask" slot="dropdown-content"
                      ><iron-icon icon="add"></iron-icon>Add Sub-Task</paper-item
                    >
                    <paper-item id="removeTask" on-click="removeTask" slot="dropdown-content"
                      ><iron-icon icon="clear"></iron-icon>Delete Task</paper-item
                    >
                  </div>
                </paper-menu-button>
              </paper-row>
              <paper-table style="overflow: hidden;" dividers>
                <paper-table-scroll id="subTaskList" on-sort-changed="taskListSortChanged">
                  <template is="dom-repeat" items="[[item.subtasks]]" as="subItem" on-dom-change="taskListDomChanged">
                    <paper-row white slot="[[getTaskSlot(subItem.status)]]" completed$="[[equal(subItem.status, 'done')]]">
                      <paper-cell icon></paper-cell>
                      <paper-cell icon drag-handle>
                        <iron-icon hover icon="katapult-misc:drag-indicator"></iron-icon>
                      </paper-cell>
                      <paper-cell icon>
                        <paper-checkbox checked="[[equal(subItem.status, 'done')]]" on-click="toggleTaskComplete"></paper-checkbox>
                      </paper-cell>
                      <paper-cell textarea>
                        <paper-textarea
                          id$="task_[[subItem.$key]]_input"
                          value="[[subItem.title]]"
                          on-keydown="taskInputKeydown"
                          no-label-float
                          on-value-changed="taskInputChanged"
                          on-focus="closeOptionsMenus"
                        ></paper-textarea>
                      </paper-cell>
                      <stop-watch
                        disabled="[[equal(subItem.status, 'done')]]"
                        path="[[tasksRefPath]]/[[item.$key]]/subtasks/[[subItem.$key]]"
                        time-stamp="[[subItem.time.begin_timestamp]]"
                      ></stop-watch>
                      <template is="dom-if" if="[[shouldShowJobLinkButton(subItem.job_link_hash, disableUserTasks)]]">
                        <paper-cell icon-button>
                          <katapult-button
                            iconOnly
                            noBorder
                            on-click="openJobLink"
                            icon="open_in_new"
                            job-link-hash="[[subItem.job_link_hash]]"
                          ></katapult-button>
                        </paper-cell>
                      </template>
                      <paper-menu-button class="optionsMenu" horizontal-align="right" vertical-align="top" allow-outside-scroll>
                        <katapult-button
                          iconOnly
                          noBorder
                          id="optionsMenuButton"
                          slot="dropdown-trigger"
                          icon="more_vert"
                        ></katapult-button>
                        <div slot="dropdown-content">
                          <paper-item id="editTask" on-click="editTask" slot="dropdown-content"
                            ><iron-icon icon="create"></iron-icon>Edit Sub-Task</paper-item
                          >
                          <paper-item id="removeTask" on-click="removeTask" slot="dropdown-content"
                            ><iron-icon icon="clear"></iron-icon>Delete Sub-Task</paper-item
                          >
                        </div>
                      </paper-menu-button>
                    </paper-row>
                  </template>
                  <template is="dom-if" if="[[shouldShowSubTaskInput(item)]]">
                    <paper-row white divider slot="after">
                      <paper-cell icon></paper-cell>
                      <paper-cell icon></paper-cell>
                      <paper-cell icon>
                        <iron-icon icon="add"></iron-icon>
                      </paper-cell>
                      <paper-cell textarea>
                        <paper-textarea
                          id="newSubTaskInput_[[item.$key]]"
                          value="[[subItem.title]]"
                          label="Sub-Task Item"
                          on-keydown="newTaskInputKeydown"
                          no-label-float
                          on-value-changed="newTaskInputChanged"
                          on-focus="closeOptionsMenus"
                        ></paper-textarea>
                      </paper-cell>
                      <paper-cell icon></paper-cell>
                    </paper-row>
                  </template>
                </paper-table-scroll>
              </paper-table>
            </div>
          </template>
          <paper-row white slot="after">
            <paper-cell icon></paper-cell>
            <paper-cell icon>
              <iron-icon icon="add"></iron-icon>
            </paper-cell>
            <paper-cell textarea>
              <paper-textarea
                id="newTaskInput"
                value="[[item.title]]"
                label="Task Item"
                on-keydown="newTaskInputKeydown"
                no-label-float
                on-value-changed="newTaskInputChanged"
                on-focus="closeOptionsMenus"
              ></paper-textarea>
            </paper-cell>
            <paper-cell icon></paper-cell>
          </paper-row>
        </paper-table-scroll>
      </paper-table>
    `;
  }

  static get properties() {
    return {
      paperTableBody: {
        type: Boolean,
        value: true
      },
      userGroup: String,
      hideTitleRow: {
        type: Boolean,
        value: false
      },
      disableUserTasks: {
        type: Boolean,
        value: false
      },
      assignedKey: {
        type: String,
        value: ''
      },
      assignedValue: {
        type: String,
        value: ''
      },
      taskList: {
        type: Object,
        value: {}
      },
      hasTasks: {
        type: Boolean,
        value: false,
        computed: 'tasksExist(taskList)',
        notify: true
      },
      disableTaskList: {
        type: Boolean,
        value: false
      },
      signedIn: {
        type: Boolean,
        value: false
      },
      jobId: {
        type: String,
        value: ''
      }
    };
  }

  static get observers() {
    return [
      'updatetaskListArray(taskList.*)',
      'updateTasksRef(userGroup)',
      'updateUserPushId(user.uid, users.*)',
      'updateOrderType(disableUserTasks)'
    ];
  }

  ready() {
    super.ready();
  }

  editTaskMembers(e) {
    this.closeOptionsMenus();
    this.editingTaskKey = e.model.item.$key;
    this.editingTaskMembers = Array.from(e.model.item.members);
    this.shadowRoot.querySelector('#taskMembersDialog').open();
  }
  editTaskMembersDropdownChanged(e) {
    let uid = e.currentTarget.value;
    if (!this.editingTaskMembers.includes(uid)) this.push('editingTaskMembers', uid);
    e.currentTarget.value = null;
  }
  async createNewTask(options) {
    options = options || {};
    options.title = options.title || '';

    let newTask = {};
    // if there is a parent key then create a subTask, otherwise create a task
    if (options.parentKey) {
      newTask = {
        seen: { [this.userPushId]: true },
        date_opened: firebase.database.ServerValue.TIMESTAMP,
        requestedBy: this.user.email,
        status: 'claimed',
        title: options.title,
        type: 'task'
      };
      if (this.disableUserTasks && this.assignedKey && this.assignedValue) {
        let jobLinkId = '';
        if (this.assignedKey == 'assigned_job') jobLinkId = this.assignedValue;
        else jobLinkId = this.assignedValue.split(':')[1];
        if (jobLinkId) {
          newTask['job_link_id'] = jobLinkId;
          newTask['assigned_job'] = jobLinkId;
          // create the hash for the link to job
          if (this.assignedKey == 'assigned_node') {
            // if we have an assigned node for the task then add that to the hash
            newTask['assigned_node'] = this.assignedValue;
            newTask['job_link_hash'] = `${jobLinkId}/n${this.assignedValue.split(':')[0]}`;
          } else {
            newTask['job_link_hash'] = `${jobLinkId}`;
          }
        }
      }
      let taskKey = FirebaseWorker.ref().push().key;
      this.addedTaskKey = taskKey;
      let update = { [taskKey]: newTask };
      if (options.index) {
        let subTaskListArray =
          SquashNulls(
            this.taskListArray.filter((task) => task.$key == options.parentKey),
            0,
            'subtasks'
          ) || [];
        let keys = subTaskListArray.map((x) => x.$key);
        keys.splice(options.index, 0, taskKey);
        await this.updateSortOrder(keys, update, { parentKey: options.parentKey });
      } else {
        await this.tasksRef.child(`${options.parentKey}/subtasks`).update(update);
      }
      return taskKey;
    } else {
      newTask = {
        assigned: this.disableUserTasks ? null : { [this.userPushId]: true },
        seen: { [this.userPushId]: true },
        date_assigned: firebase.database.ServerValue.TIMESTAMP,
        date_opened: firebase.database.ServerValue.TIMESTAMP,
        requestedBy: this.user.email,
        status: 'claimed',
        title: options.title,
        type: 'task'
      };
      if (this.disableUserTasks && this.assignedKey && this.assignedValue) {
        let jobLinkId = '';
        if (this.assignedKey == 'assigned_job') jobLinkId = this.assignedValue;
        else jobLinkId = this.assignedValue.split(':')[1];
        if (jobLinkId) {
          newTask['job_link_id'] = jobLinkId;
          newTask['assigned_job'] = jobLinkId;
          // create the hash for the link to job
          if (this.assignedKey == 'assigned_node') {
            // if we have an assigned node for the task then add that to the hash
            newTask['assigned_node'] = this.assignedValue;
            newTask['job_link_hash'] = `${jobLinkId}/n${this.assignedValue.split(':')[0]}`;
          } else {
            newTask['job_link_hash'] = `${jobLinkId}`;
          }
        }
      }
      let taskKey = FirebaseWorker.ref().push().key;
      this.addedTaskKey = taskKey;
      let update = { [taskKey]: newTask };
      if (options.index) {
        let keys = this.taskListArray.map((x) => x.$key);
        keys.splice(options.index, 0, taskKey);
        await this.updateSortOrder(keys, update);
      } else {
        await this.tasksRef.update(update);
      }
      return taskKey;
    }
  }
  editTask(e) {
    this.closeOptionsMenus();
    // clear the previous selectedTask
    this.selectedTaskData = {};
    this.submissionType = 'Edit';
    if (e.model.subItem) {
      this.selectedTaskData = (SquashNulls(this.taskList, e.model.subItem.$parentKey, 'subtasks') || []).find(
        (x) => x.$key == e.model.subItem.$key
      );
      this.tasksPath = `tasks/${e.model.subItem.$parentKey}/subtasks`;
    } else {
      this.selectedTaskData = this.taskList[e.model.item.$key];
      this.tasksPath = 'tasks';
    }
    this.$.taskSubmissionForm.open();
    // sets the scrollable div to position relative, for drop-down purposes
    this.$.taskSubmissionForm.$.taskFormScrollable.$.scrollable.style.position = 'relative';
  }
  addSubTask(e) {
    this.closeOptionsMenus();
    // clear the previous selectedTask
    this.selectedTaskData = {};
    if (this.disableUserTasks) {
      this.selectedTaskData[this.assignedKey] = this.assignedValue;
    }
    this.submissionType = 'Create';
    this.tasksPath = `tasks/${e.model.item.$key}/subtasks`;
    this.shadowRoot.querySelector('#taskSubmissionForm').open();
    // sets the scrollable div to position relative, for drop-down purposes
    this.$.taskSubmissionForm.$.taskFormScrollable.$.scrollable.style.position = 'relative';
  }
  equal(a, b) {
    return a == b;
  }
  shouldShowSubTaskInput(item) {
    if (item.subtasks && item.status != 'done') return true;
    else return false;
  }
  getTaskSlot(status) {
    return status == 'done' ? 'after' : 'sortable';
  }
  getInputByKey(taskKey) {
    return this.shadowRoot.querySelector(`#task_${taskKey}_input`);
  }
  getTrue() {
    return true;
  }
  getUserEmail(pushId) {
    let user = this.get(`users.${pushId}`);
    if (user) return user.email;
  }
  taskInputChanged(e) {
    if (e.model.subItem) {
      this.tasksRef.child(`${e.model.parentModel.item.$key}/subtasks/${e.model.subItem.$key}/title`).set(e.detail.value);
    } else {
      this.tasksRef.child(`${e.model.item.$key}/title`).set(e.detail.value);
    }
  }
  taskInputKeydown(e) {
    this.closeOptionsMenus();
    // check if we are dealing with subtasks or tasks
    if (e.model.subItem) {
      let subTaskListArray =
        SquashNulls(
          this.taskListArray.filter((task) => task.$key == e.model.parentModel.item.$key),
          0,
          'subtasks'
        ) || [];
      if (e.key == 'Backspace' && e.currentTarget.value == '' && e.model.index > 0) {
        e.preventDefault();
        let prevTaskKey = subTaskListArray[e.model.index - 1].$key;
        this.removeTask(e);
        let input = this.getInputByKey(prevTaskKey);
        if (input) input.focus();
        setTimeout(() => {});
      } else if (e.key == 'Enter' && !e.shiftKey) {
        if (e.model.index == subTaskListArray.length - 1) {
          this.shadowRoot.querySelector(`#newSubTaskInput_${e.model.parentModel.item.$key}`).focus();
        } else {
          if (!this.addedTaskKey) {
            this.createNewTask({ index: e.model.index + 1, parentKey: e.model.parentModel.item.$key });
          }
        }
        e.preventDefault();
      }
    } else {
      if (e.key == 'Backspace' && e.currentTarget.value == '' && e.model.index > 0) {
        e.preventDefault();
        let prevTaskKey = this.taskListArray[e.model.index - 1].$key;
        this.removeTask(e);
        let input = this.getInputByKey(prevTaskKey);
        if (input) input.focus();
        setTimeout(() => {});
      } else if (e.key == 'Enter' && !e.shiftKey) {
        if (e.model.index == this.taskListArray.length - 1) {
          this.shadowRoot.querySelector('#newTaskInput').focus();
        } else {
          if (!this.addedTaskKey) {
            this.createNewTask({ index: e.model.index + 1 });
          }
        }
        e.preventDefault();
      }
    }
  }
  taskListDomChanged(e) {
    if (this.addedTaskKey) {
      setTimeout(() => {
        let input = this.getInputByKey(this.addedTaskKey);
        if (input) {
          input.focus();
          this.addedTaskKey = null;
          this.shadowRoot.querySelector('#newTaskInput').value = '';
          let subTaskInputs = this.shadowRoot.querySelectorAll(`[id*='newSubTaskInput']`) || [];
          subTaskInputs.forEach((input) => (input.value = ''));
        }
      });
    }
  }
  async taskListSortChanged(e) {
    this.closeOptionsMenus();
    let keys = [];
    let sortListKeys = [];
    let workingWithSubTasks = e.currentTarget.id == 'subTaskList' ? true : false;
    if (workingWithSubTasks) {
      let subTaskListArray =
        SquashNulls(
          this.taskListArray.filter((task) => task.$key == e.model.item.$key),
          0,
          'subtasks'
        ) || [];
      keys = subTaskListArray.map((x) => x.$key);
      sortListKeys = subTaskListArray.filter((task) => this.getTaskSlot(task.status) == 'sortable').map((x) => x.$key);
    } else {
      keys = this.taskListArray.map((x) => x.$key);
      sortListKeys = this.taskListArray.filter((task) => this.getTaskSlot(task.status) == 'sortable').map((x) => x.$key);
    }

    // We need to map the indexes from the smaller list to the big list.  Do this by getting the item at the small list index and then finding the index of that same item in the big list.
    let mappedPrevIndex = keys.indexOf(sortListKeys[e.detail.prevIndex]);
    let mappedIndex = keys.indexOf(sortListKeys[e.detail.index]);
    let removed = keys.splice(mappedPrevIndex, 1);
    keys.splice(mappedIndex, 0, removed);
    if (workingWithSubTasks) {
      await this.updateSortOrder(keys, null, { parentKey: e.model.item.$key });
    } else {
      await this.updateSortOrder(keys);
    }
  }
  newTaskInputChanged(e) {
    let value = e.detail.value;
    if (e.currentTarget.id && e.currentTarget.id.includes('newSubTaskInput')) {
      if (this.addedTaskKey) {
        this.tasksRef.child(`${e.model.item.$key}/subtasks/${this.addedTaskKey}/title`).set(value);
      } else if (value) {
        let subTaskListArray =
          SquashNulls(
            this.taskListArray.filter((task) => task.$key == e.model.item.$key),
            0,
            'subtasks'
          ) || [];
        this.createNewTask({ title: value, index: subTaskListArray.length, parentKey: e.model.item.$key });
      }
    } else {
      if (this.addedTaskKey) {
        this.tasksRef.child(`${this.addedTaskKey}/title`).set(value);
      } else if (value) {
        this.createNewTask({ title: value, index: this.taskListArray.length });
      }
    }
  }
  newTaskInputKeydown(e) {
    if (e.key == 'Backspace') {
      e.preventDefault();
      let taskKey = '';
      // check if we are dealing with subtasks or tasks
      if (e.currentTarget.id && e.currentTarget.id.includes('newSubTaskInput')) {
        let subTaskListArray =
          SquashNulls(
            this.taskListArray.filter((task) => task.$key == e.model.item.$key),
            0,
            'subtasks'
          ) || [];
        taskKey = Array.from(subTaskListArray)
          .reverse()
          .find((x) => x.status != 'done').$key;
      } else {
        taskKey = Array.from(this.taskListArray)
          .reverse()
          .find((x) => x.status != 'done').$key;
      }
      let input = this.getInputByKey(taskKey);
      if (input) input.focus();
    } else if (e.key == 'Enter' && !e.shiftKey) {
      e.preventDefault();
    }
  }
  async removeTask(e) {
    this.closeOptionsMenus();
    // check if we are dealing with subtasks or tasks
    if (e.model.subItem) {
      let taskKey = e.model.subItem.$key;

      let update = {};
      for (let pushId in e.model.subItem.assigned) update[`${pushId}/assigned/${this.editingTaskKey}`] = null;
      await this.tasksRef.parent.child('coders').update(update);

      if (taskKey) await this.tasksRef.child(`${e.model.subItem.$parentKey}/subtasks/${taskKey}`).remove();
    } else {
      let taskKey = e.model.item.$key;

      let update = {};
      for (let pushId in e.model.item.assigned) update[`${pushId}/assigned/${this.editingTaskKey}`] = null;
      await this.tasksRef.parent.child('coders').update(update);

      if (taskKey) await this.tasksRef.child(taskKey).remove();
    }
  }
  removeTaskMembers(e) {
    this.splice('editingTaskMembers', e.model.index, 1);
  }
  resizeTaskMembersDialog() {
    this.shadowRoot.querySelector('#taskMembersDialog').notifyResize();
  }
  async saveTaskMembers(e) {
    this.savingTaskMembers = true;

    let assigned = this.disableUserTasks ? {} : { [this.userPushId]: true };
    this.editingTaskMembers.forEach((pushId) => {
      assigned[pushId] = true;
    });
    await this.tasksRef.child(`${this.editingTaskKey}/assigned`).set(assigned);
    if (Object.keys(assigned).length > 0) {
      await this.tasksRef.child(`${this.editingTaskKey}`).update({ status: 'claimed' });
    } else {
      await this.tasksRef.child(`${this.editingTaskKey}`).update({ status: 'open' });
    }

    let update = {};
    for (let pushId in this.get(`taskList.${this.editingTaskKey}.assigned`)) update[`${pushId}/assigned/${this.editingTaskKey}`] = null;
    for (let pushId in assigned) update[`${pushId}/assigned/${this.editingTaskKey}`] = true;
    await this.tasksRef.parent.child('coders').update(update);

    this.savingTaskMembers = false;
    this.shadowRoot.querySelector('#taskMembersDialog').close();
  }
  async toggleTaskComplete(e) {
    e.currentTarget.disabled = true;
    e.currentTarget.checked = !e.currentTarget.checked;
    let update = {};
    // check if we are dealing with subtasks or tasks
    if (e.model.subItem) {
      if (e.currentTarget.checked) {
        if (!this.disableUserTasks || Object.keys(e.model.subItem.assigned).length > 0) {
          update.status = 'claimed';
        } else {
          update.status = 'open';
        }
        update.date_completed = null;
      } else {
        update.status = 'done';
        update.date_completed = firebase.database.ServerValue.TIMESTAMP;
      }
      this.tasksRef.child(`${e.model.subItem.$parentKey}/subtasks/${e.model.subItem.$key}`).update(update);
    } else {
      if (e.currentTarget.checked) {
        if (!this.disableUserTasks || Object.keys(e.model.item.assigned).length > 0) {
          update.status = 'claimed';
        } else {
          update.status = 'open';
        }
        update.date_completed = null;
      } else {
        update.status = 'done';
        update.date_completed = firebase.database.ServerValue.TIMESTAMP;
      }
      // there are any subtasks update them to be the same status and date_completed as the parent task
      if (e.model.item.subtasks && e.model.item.subtasks.length > 0) {
        e.model.item.subtasks.forEach((subtask) => {
          update[`subtasks/${subtask.$key}/status`] = update.status;
          update[`subtasks/${subtask.$key}/date_completed`] = update.date_completed;
        });
      }
      this.tasksRef.child(e.model.item.$key).update(update);
    }

    e.currentTarget.disabled = false;
  }
  openJobLink(e) {
    if (e.currentTarget.jobLinkHash) {
      OpenPage('map', {
        hash: e.currentTarget.jobLinkHash,
        target: '_blank'
      });
    }
  }
  updatetaskListArray() {
    this.taskListArray = ToArray(this.taskList)
      .map((task) => {
        if (task.subtasks)
          task.subtasks = JSON.parse(
            JSON.stringify(
              ToArray(task.subtasks)
                .map((subTask) => {
                  subTask.$parentKey = task.$key;
                  return subTask;
                })
                .sort((a, b) => {
                  let aOrder = Path.get(a, `${this.orderType}.${this.user.uid}`);
                  let bOrder = Path.get(b, `${this.orderType}.${this.user.uid}`);
                  // let aDone = Path.get(a, 'status') == 'done';
                  // let bDone = Path.get(b, 'status') == 'done';
                  // if (aDone && !bDone) return 1;
                  // if (bDone && !aDone) return -1;
                  if (aOrder != null && bOrder != null) return aOrder - bOrder;
                  if (aOrder == null) return 1;
                  if (bOrder == null) return -1;
                  return 0;
                })
            )
          );
        task.members = Object.keys(task.assigned || {}).filter((pushId) => (this.disableUserTasks ? true : pushId != this.userPushId));
        let seenCacheValPath = `seenCache.${task.$key}.${this.user.uid}`;
        let seenCacheVal = this.get(seenCacheValPath);
        let seenVal = Path.get(task, `seen.${this.user.uid}`);
        if (seenCacheVal == undefined) {
          Path.set(this, seenCacheValPath, seenVal || false);
          task.seenVal = seenVal;
        } else {
          task.seenVal = seenCacheVal;
        }
        return task;
      })
      .sort((a, b) => {
        let aOrder = Path.get(a, `${this.orderType}.${this.user.uid}`);
        let bOrder = Path.get(b, `${this.orderType}.${this.user.uid}`);
        // let aDone = Path.get(a, 'status') == 'done';
        // let bDone = Path.get(b, 'status') == 'done';
        // if (aDone && !bDone) return 1;
        // if (bDone && !aDone) return -1;
        if (aOrder != null && bOrder != null) return aOrder - bOrder;
        if (aOrder == null) return 1;
        if (bOrder == null) return -1;
        return 0;
      });

    this.markSeenDebouncer = Debouncer.debounce(this.markSeenDebouncer, timeOut.after(1000), () => {
      let update = {};
      this.taskListArray.forEach((task) => {
        let seenVal = Path.get(task, `seen.${this.user.uid}`);
        if (!seenVal) {
          update[`${task.$key}/seen/${this.user.uid}`] = true;
        }
      });
      if (Object.keys(update).length) this.tasksRef.update(update);
    });
  }
  async updateSortOrder(keys, update, options) {
    options = options || {};
    update = update || {};
    keys = keys || this.taskListArray.map((x) => x.$key);
    keys.forEach((key, i) => {
      if (update[key] != null) {
        Path.set(update[key], `${this.orderType}.${this.user.uid}`, i);
      } else {
        update[`${key}/${this.orderType}/${this.user.uid}`] = i;
      }
    });
    if (options.parentKey) {
      await this.tasksRef.child(`${options.parentKey}/subtasks`).update(update);
    } else {
      await this.tasksRef.update(update);
    }
  }
  updateTasksRef() {
    this.tasksRefPath = `photoheight/company_space/${this.userGroup}/tasks/tasks`;
    this.tasksRef = FirebaseWorker.ref(this.tasksRefPath);
  }
  updateUserPushId() {
    let temp = null;
    if (this.users) {
      let user = ToArray(this.users).find((x) => x.uid == this.user.uid);
      if (user && user.$key) temp = user.$key;
    }
    this.userPushId = temp;
  }
  updateOrderType() {
    // if we are dealing with /home then use userOrder if /map then mapOrder
    if (this.disableUserTasks == true) this.orderType = 'mapOrder';
    else this.orderType = 'userOrder';
  }
  tasksExist(taskList) {
    if (taskList && Object.keys(taskList).length > 0) return true;
    else return false;
  }
  getTaskListOrderByChild(disableUserTasks, userPushId, assignedKey) {
    if (disableUserTasks) {
      if (assignedKey) {
        this.disableTaskList = false;
        return `${assignedKey}`;
      } else {
        this.disableTaskList = true;
      }
    } else {
      this.disableTaskList = false;
      return `assigned/${userPushId}`;
    }
  }
  getTaskListEqualTo(disableUserTasks, assignedValue) {
    if (disableUserTasks) {
      if (assignedValue) {
        this.disableTaskList = false;
        return assignedValue;
      } else {
        this.disableTaskList = true;
      }
    } else {
      this.disableTaskList = false;
      return true;
    }
  }
  closeOptionsMenus() {
    let optionsMenus = this.shadowRoot.querySelectorAll('.optionsMenu');
    optionsMenus.forEach((menu) => {
      menu.close();
    });
  }
  shouldShowJobLinkButton(jobLinkHash, disableUserTasks) {
    // if the we are not in /map and there is a job hash then show the job link button
    if (!disableUserTasks && jobLinkHash) {
      return true;
    } else {
      return false;
    }
  }
}
window.customElements.define('katapult-task-widget', KatapultTaskWidget);
